<template>
  <div class="inline-flex items-center gap-3" :class="{ '*:cursor-not-allowed!': disabled }">
    <label
      v-if="title || $slots['title']"
      class="label text-buttons text-beige-90"
      :for="`input${uid}`"
    >
      <slot v-if="$slots['title']" name="title"></slot>
      <template v-else> {{ title }} </template>
    </label>
    <button
      :id="`input${uid}`"
      class="button bg-beige-10 shrink-0 rounded-full"
      :class="{
        'button--on bg-blue-50!': model,
        'opacity-50': disabled,
        'cursor-pointer': !disabled,
      }"
      role="switch"
      type="button"
      :disabled="disabled"
      :aria-checked="model"
      @click="model = !model"
    >
      <span
        class="knob bg-white-1 block rounded-full"
        :class="{ 'knob--on': model }"
        aria-hidden="true"
      >
      </span>
    </button>
  </div>
</template>

<script setup>
import { getCurrentInstance } from "vue";
const { uid } = getCurrentInstance();

const props = defineProps({
  title: { type: [String, Boolean], default: false },
  trueValue: { type: [String, Number, Boolean], default: true },
  falseValue: { type: [String, Number, Boolean], default: false },
  disabled: { type: Boolean, default: false },
});

const model = defineModel({
  type: [String, Number, Boolean],
  default: false,
  get: v => v === props.trueValue,
  set: v => (v ? props.trueValue : props.falseValue),
});
</script>

<style lang="scss" scoped>
.button {
  width: 38px;
  height: 25px;
  transition: background 100ms ease-in-out;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid var(--color-blue-50);
    outline-offset: 2px;
  }
}

.knob {
  width: 21px;
  height: 21px;
  transition: transform 300ms ease-in-out;
  transform: translateX(2px);
  box-shadow: 0px 3px 9px 0px rgba(92, 104, 124, 0.16);

  &--on {
    transform: translateX(calc(100% - 10.5px + 4px));
  }
}
</style>
